import { getUUID } from "../helpers/helpers";
import store from "../redux/store";
import { conditions } from "../helpers/conditions/conditions";
import { ConditionName } from "../interfaces/enums";
import { apiCaller } from "../services/apiCaller";
import { API } from "../services/services";
import { featureToggle } from "../helpers";

export const sendFluentLog = (data:any) => {
    const { poll_emoji } = store.getState().user.settings;
    const { params, details } = store.getState().videoData;
    let _data = {
        ...data,
        timestamp: Date.now(),
        clientUUID: getUUID(),
        uuid: getUUID(),
        link: window.location.href,
        user_id: conditions(ConditionName.isLiveParam) ? Number(params.id) : details.user_id,
        live_id: conditions(ConditionName.isLiveParam) ? details.id : null,
        format: data.category === "feedback" ? (conditions(ConditionName.isStaticFormat) ? "static" : "hls") : undefined
    };
    if (conditions(ConditionName.isLiveParam)) _data[featureToggle] = poll_emoji;
    apiCaller({ url: API().logs, method: "post", data: _data });
}
